import { h } from '@stencil/core';
import state from 'store';
import { i18n } from 'i18n';
import { initNewChatTour } from 'utils/productTour';
import { triggerTrackEvent } from 'utils/events';
import { triggerLoadCustomChat } from 'utils/events';
import initParams from 'store/initParams';

export default function RecoverChatModal({ show }: { show: boolean }) {
  const onClose = () => {
    triggerTrackEvent({
      event_type: 'user',
      event_name: `recover_modal_close`,
    });
    state.showFullScreenModal = null;
    initNewChatTour(initParams.isMobile);
  };

  const newChat = () => {
    triggerTrackEvent({
      event_type: 'user',
      event_name: `click_start_new_chat`,
    });

    triggerLoadCustomChat(true);
    state.showFullScreenModal = null;
  };

  return show ? (
    <div id="recover-chat-modal" role="presentation" class={'eva-3-modal fullscreen-modal -sm -show-sticky-footer -show-modal'}>
      <div class="modal-header" role="presentation">
        <i class="eva-3-icon-cross modal-close -eva-3-mr-md" role="button" tabindex="0" aria-label={i18n.t.previousChatModal.close} onClick={() => onClose()}></i>

        <div class="modal-title-container">
          <h4 class="eva-3-h4">{i18n.t.previousChatModal.title}</h4>
        </div>
      </div>
      <div class="modal-content" role="presentation">
        <p class="eva-3-body-1 text">
          {i18n.t.previousChatModal.text} {i18n.t.previousChatModal.question}
        </p>
      </div>
      <div class="modal-footer">
        <div class="actions">
          <button type="button" class="eva-3-btn -eva-3-mr-sm -lg -link" onClick={() => newChat()}>
            <em class="btn-text -secondary">{i18n.t.previousChatModal.cancel}</em>
          </button>
          <button type="button" class="eva-3-btn -lg -primary" onClick={() => onClose()}>
            <em class="btn-text">{i18n.t.previousChatModal.recover}</em>
          </button>
        </div>
      </div>
    </div>
  ) : null;
}
